import { render } from "./OrdreOverview.vue?vue&type=template&id=28ee00d4"
import script from "./OrdreOverview.vue?vue&type=script&lang=js"
export * from "./OrdreOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__